import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import Joi from 'joi-full';
import {
  fetchHourlyWageRules,
  saveHourlyWageRules,
} from '../actions';

import withNotifications from '../../../common/withNotifications';
import { syncValidateData } from '../../../common/validator';
import HourlyWageRules from '../components/HourlyWageRules';
import { getShop, getHourlyWageRules } from '../reducers/index';
import { updateShop } from '../../../main/shops/actions';

const schema = {
  calculateHourlyWages: Joi.boolean().optional().allow(null),
  minimumWage: Joi.number().min(0).required(),
  lowerOvertimeCommissionPercentage: Joi.number().min(0).required(),
  upperOvertimeCommissionPercentage: Joi.number().min(0).required(),
  regularHours: Joi.number().min(0).required(),
  upperOvertimeHours: Joi.number().min(0).required(),
  consecutiveDays: Joi.number().min(0).required(),
  weeklyHours: Joi.number().min(0).required(),
};

const HOURLY_WAGE_RULES_FORM = 'hourlyWageRulesForm';

const selector = formValueSelector(HOURLY_WAGE_RULES_FORM);

const form = reduxForm({
  form: HOURLY_WAGE_RULES_FORM,
  enableReinitialize: true,
  validate: values => syncValidateData(values, schema),
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.addNotification({
      title: 'Success',
      level: 'success',
      message: 'Hourly wage rules saved successfully',
    });
  },
});

const defaultRules = {
  minimumWage: 1200,
  lowerOvertimeCommissionPercentage: 1.5,
  upperOvertimeCommissionPercentage: 2,
  regularHours: 8,
  upperOvertimeHours: 12,
  consecutiveDays: 7,
  weeklyHours: 40,
};

const mapStateToProps = (state, ownProps) => {
  const shop = getShop(state, ownProps.params.id);
  const wageRules = getHourlyWageRules(state) || defaultRules;

  return {
    shop,
    isEnabled: selector(state, 'calculateHourlyWages'),
    initialValues: {
      calculateHourlyWages: shop.calculateHourlyWages,
      adpReport: shop.adpReport,
      adpCoCode: shop.adpCoCode,
      ...wageRules,
    },
  };
};

const mapDispatchToProps = {
  fetchHourlyWageRules,
  saveHourlyWageRules,
  updateShop,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSubmit: props => async (data) => {
      if (data.calculateHourlyWages !== props.shop.calculateHourlyWages
        || data.adpReport !== props.shop.adpReport
        || data.adpCoCode !== props.shop.adpCoCode) {
        const updateData = {
          calculateHourlyWages: data.calculateHourlyWages,
          adpReport: data.adpReport,
          adpCoCode: data.adpReport ? data.adpCoCode : undefined,
        };

        if (data.calculateHourlyWages) {
          updateData.timeTrackingEnabled = true;
        }

        await props.updateShop(props.shop.id, { ...updateData }, props.shop);
      }

      if (data.calculateHourlyWages) {
        props.saveHourlyWageRules(props.params.id, data);
      }
    },
    fetch: props => () => {
      if (props.shop.calculateHourlyWages) {
        return props.fetchHourlyWageRules(props.params.id);
      }

      return false;
    },
  }),
  withNotifications,
  form,
  lifecycle({
    componentDidMount() {
      this.props.fetch();
    },
  }),
)(HourlyWageRules);
